import { render, staticRenderFns } from "./BussinessListAddPop.vue?vue&type=template&id=2489f9ba&"
import script from "./BussinessListAddPop.vue?vue&type=script&lang=js&"
export * from "./BussinessListAddPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports